import React, { useState } from "react";
import { SetterOrUpdater } from "recoil";
import RefreshButton from "./RefreshButton";
import SearchButton from "./SearchButton";
import TextInput from "./TextInput";

export default function TableFilters(props: {
  filterText:
    | SetterOrUpdater<string>
    | React.Dispatch<React.SetStateAction<string>>;
  setRecent?: React.Dispatch<React.SetStateAction<string>>;
  recentText?: string;
  defaultText: string;
  textInputName: string;
  columnDetails: string;
  disabledButton: boolean;
  disabledTextBox: boolean;
}) {
  const {
    setRecent,
    recentText,
    filterText,
    textInputName,
    columnDetails,
    disabledButton,
    disabledTextBox,
    defaultText,
  } = props;
  const [inputValue, setInputValue] = useState("");
  const [searched, setSearched] = useState(false);
  if (recentText) {
    filterText("");
  }
  const FilterData = () => {
    filterText(inputValue != "" ? inputValue : defaultText);
    if (setRecent) setRecent("");
    setSearched(false);
  };

  return (
    <div className="">
      <div className="flex flex-row space-x-2">
        <TextInput
          name={textInputName}
          placeholder={recentText ? recentText : columnDetails}
          value={inputValue != "" || searched ? inputValue : defaultText}
          disabled={disabledTextBox ? true : false}
          onChange={(e) => {
            setInputValue(e.target.value);
            e.target.value === "" && filterText("");
            setSearched(true);
            if (e.target.value == "" && setRecent) {
              setRecent("");
            }
          }}
        />
        <SearchButton
          buttonValue="Search"
          className={
            (defaultText == "" && inputValue === "") || disabledButton
              ? "opacity-50"
              : "opacity-100"
          }
          disabled={
            (defaultText == "" && inputValue === "") || disabledButton
              ? true
              : false
          }
          onClick={() => {
            FilterData();
          }}
        />
        <div>
          <RefreshButton
            className={
              (defaultText == "" && inputValue === "" && recentText === "") ||
              disabledButton
                ? "opacity-50"
                : "opacity-100"
            }
            disabled={
              (defaultText == "" && inputValue === "" && recentText === "") ||
              disabledButton
                ? true
                : false
            }
            onClick={() => {
              filterText("");
              setInputValue("");
              if (setRecent) setRecent("");
              setSearched(false);
            }}
          />
        </div>
      </div>
    </div>
  );
}
